import { Link, Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Pathless layout das telas de analytics (Fase 8). Filhos: index/conteudo/
 * conversoes/geografia/config. RBAC via /_auth (já exige login) — a API
 * adicionalmente exige papel ≥ editor; aqui o link só aparece no sidebar,
 * páginas filhas re-validam em runtime via fetch (401 → erro inline).
 */
export const Route = createFileRoute('/_auth/analytics')({
  component: AnalyticsLayout,
});

const SUBNAV = [
  { to: '/analytics', label: 'Visão geral', end: true },
  { to: '/analytics/conteudo', label: 'Conteúdo' },
  { to: '/analytics/conversoes', label: 'Conversões' },
  { to: '/analytics/geografia', label: 'Geografia' },
  { to: '/analytics/config', label: 'Configurações' },
] as const;

function AnalyticsLayout() {
  return (
    <div className="page">
      <header className="page-head">
        <p className="eyebrow">/ Desempenho</p>
        <h1 className="page-title">Audiência</h1>
        <p className="page-sub">
          Quantas pessoas visitam o site, de onde vêm, o que leem e quantas acabam entrando em
          contato.
        </p>
      </header>

      <nav className="analytics-subnav" aria-label="Seções de analytics">
        {SUBNAV.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="analytics-subnav__link"
            activeProps={{ className: 'analytics-subnav__link is-active' }}
            activeOptions={{ exact: 'end' in item ? item.end : false }}
          >
            {item.label}
          </Link>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
